import { ref, computed, onMounted, onUnmounted } from 'vue';
import { defineStore } from 'pinia';
import  axios  from 'axios'
import { API_URL } from '@/utils/constans'

export const useSettingsStore = defineStore('settings', () => {

	const isClient = typeof window !== 'undefined';	

	const settings = ref({})

	const widthWindow = ref(null);
    const heightWindow = ref(null);
	if(isClient) {
		widthWindow.value = window.innerWidth;
		heightWindow.value = window.innerHeight;
	}
	const cookies = computed(() => settings.value.documents?.cookies);
	const offer = computed(() => settings.value.documents?.offer);
	const policy_personal_data = computed(() => settings.value.documents?.policy_personal_data);
	const rules = computed(() => settings.value.documents?.rules);

	const supportPhone = computed(() => settings.value.support?.phone_number);
	const supportTelegram = computed(() => settings.value.support?.telegram);
	const supportEmail = computed(() => settings.value.support?.email);
	const supportWhatsapp = computed(() => settings.value.support?.whatsapp);

	const contactsEmail = computed(() => settings.value.contacts?.email);
	const contactsPhone = computed(() => settings.value.contacts?.phone_number);
	const contactsAddress = computed(() => settings.value.contacts?.address);
	const contactsWorkTime = computed(() => settings.value.contacts?.work_time);

	
	const mainSettings = async() => {
		try{
			const response = await axios.get(`${API_URL}/api/main/settings/certificates`);
			settings.value = response.data;
		} catch(error) {
			console.log('error:',error);
		}
	}
	
	const updateWidthWindow = () => { 
        widthWindow.value = window.innerWidth;
        heightWindow.value = window.innerHeight; 
    };
    onMounted(() => {
        window.addEventListener('resize', updateWidthWindow);        
    });
   
    onUnmounted(() => {
        window.removeEventListener('resize', updateWidthWindow);
    });

    return {
		mainSettings,

		settings,
		supportPhone,
		supportTelegram,
		supportEmail,
		supportWhatsapp,

		cookies,
		offer,
		policy_personal_data,
		rules,
		contactsAddress,
		contactsEmail,
		contactsPhone,
		contactsWorkTime
	}
})
